import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
  * **WebRezPro v2**
  *
  * @exports bs_445
  * @category engines
  */
function factory({ window, document, thn }) {

  const engine = {};

  /**
    * @memberOf module:bs_445
    * @see {@link is_user_logged}
    *
    * @param {object} ctx - The context object.
    */
  engine.isUserLogged = function isUserLogged(ctx) {
    const isLogged = false;
    return isLogged;
  };

  /**
    *
    * @memberOf module:bs_445
    *
    * @param {object} ctx - The context object.
    */
  engine.boot = function boot() {
    const container = document.querySelector('#Modal_availability_select');

    if (container) {
      let refreshPage = thn.debounce(thn.pageCheck, 800);
      thn.observeDom(container, refreshPage, {
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(container, refreshPage);
        refreshPage = null;
      });
    }
    if (container && !thn.isVisible(container)) {
      const loading = thn.isVisible(document.querySelectorAll('.loader'));

      if (!loading) {
        let refreshPage = thn.debounce(thn.pageCheck, 800);
        thn.observeDom(container, refreshPage, {
          attributes: true,
        });

        thn.pageUnload(() => {
          refreshPage.cancel();
          thn.stopObserveDom(container, refreshPage);
          refreshPage = null;
        });
      }
    }

  };

  /**
    * @memberOf module:bs_445
    * @this thn.widgets.price
    * @see {@link Price#observe_dom}
    *
    * @param {object} ctx - The context object.
    */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const resultContainer = document.querySelector('.tab-content, #body');

    if (resultContainer) {
      let refreshPrice = thn.debounce(() => {
        const loading = thn.isVisible(document.querySelectorAll('.loader'));
        if (!loading) {
          thn.widgets.price.refresh();
        }
      }, 800);

      thn.observeDom(resultContainer, refreshPrice, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(resultContainer, refreshPrice);
        refreshPrice = null;
      });
    }
  };

  /**
    * @memberOf module:bs_445
    * @see {@link generate_search_url}
    *
    * @param {object} ctx - The context object.
    */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/secure.webrez/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
    *
    * @memberOf module:bs_445
    *
    */
  const roomDetailsParseData = (numAdults, numChildren) => {
    const roomsArray = [...document.querySelectorAll('.tab-content div .col-md-6')];

    if (thn.empty(roomsArray)) {
      return {};
    }

    const filteredRooms = roomsArray.filter((room) => {
      const hasCloseMatch = room.querySelector('.photo_item_box[data-bs-original-title*="Close match"]');
      const hasBorderWarning = room.querySelector('.border-warning');
      return !(hasCloseMatch || hasBorderWarning);
    });

    const roomsInfo = filteredRooms
      .map((room) => {
        const roomName = room?.querySelector('.crsUnitName')?.textContent.trim();
        if (!roomName) {
          return null;
        }
        const roomType = getRoomType(roomName);
        const roomRatesArray = [...room.querySelectorAll('div .d-flex.collapse')];
        const ratesFilter = roomRatesArray.filter((rateEl) => !rateEl.querySelector('.crsBadges'));
        const roomRates = ratesFilter
          .map((rate) => {
            const rateName = rate.querySelector('.crsRateName')?.textContent?.trim();
            const price = thn.parseNumber(rate.querySelector('.crsRateValue')?.textContent);
            const hasBreakfast = false;
            const isRefundable = false;

            const infoRate = {
              id: '',
              name: rateName,
              totalNight: price,
              breakfast: hasBreakfast,
              refundable: isRefundable,
            };

            return infoRate;
          });

        return {
          id: '',
          name: roomName,
          adults: numAdults,
          children: numChildren,
          type: roomType,
          prices: roomRates,
        };
      });

    return roomsInfo;
  };

  /**
  * @memberOf module:bs_445
  * @this thn.widgets.price
  * @see {@link Price#set_data}
  *
  * @param {object} ctx - The context object.
  */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    if (thn.isVisible(document.querySelector('.loader'))) {
      return widgetData;
    }

    // Dates
    const dateBegin = thn.parseUrlParameter('date_from');
    const dateEnd = thn.parseUrlParameter('date_to');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
      widgetData.dateEnd = dateEnd.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
    }

    // Adults & Children
    const adults = thn.parseNumber(thn.parseUrlParameter('num_adults')) || 1;
    const children = thn.parseNumber(thn.parseUrlParameter('num_children')) || 0;
    const infants = thn.parseNumber(thn.parseUrlParameter('num_babies')) || 0;
    const totalChildren = children + infants;

    const roomInfo = {
      adults: adults,
      children: totalChildren,
      childrenAges: [],
    };

    if (children) {
      for (let i = 0; i < children; i += 1) {
        roomInfo.childrenAges.push(10);
      }
    }

    if (infants) {
      for (let i = 0; i < infants; i += 1) {
        roomInfo.childrenAges.push(3);
      }
    }

    widgetData.roomsDispo = [roomInfo];

    // Prices & Currency || No Rooms
    const pricesArray = [...document.querySelectorAll('.tab-content .col-md-6 div > div.d-flex.collapse, .ContainerObjectContentDiv .col-md-6 div > div.d-flex.collapse')];
    // Rates with alternative dates and guests are included, so we have to discard them.
    const ratesFilter = pricesArray.filter((rateEl) => !rateEl.querySelector('.crsBadges'));
    const prices = ratesFilter.map((price) => thn.parseNumber(price.querySelector('.crsRateValue')?.textContent)).filter(Boolean);
    const currency = thn.parseCurrency(thn.parseUrlParameter('currency_abrev')) || 'CAD';
    const noAvailability = (thn.isVisible(document.querySelector('.RoomNotAvailableNotice')) || document.querySelector('.photo_item_box[data-bs-original-title*="Close match"]')) && thn.empty(prices);

    if (!thn.empty(prices) && currency) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(adults, totalChildren);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_445
   * @this thn.widgets.booking
   * @see {@link Booking#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const bookingData = dataLayer.find((item) => item?.[1] === 'purchase')?.[2];
    const bookingId = bookingData?.transaction_id || thn.objectGet(dataLayer, 'id', { first: false }) || thn.dataLayerHelper.get('ecommerce.id');

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }
    widgetData.bookingId = bookingId;

    // Dates
    const dates = document.querySelectorAll('.kl-table-subblock div:nth-child(2) > span');
    const ecommerceData = thn.dataLayerHelper.get('ecommerce.items') || thn.dataLayerHelper.get('ecommerce.purchase');
    let dateBegin = dates?.[0] ? translateDate(dates[0]?.textContent, thn.data.language) : ecommerceData?.[0]?.arrival;
    let dateEnd = dates?.[1] ? translateDate(dates[1]?.textContent, thn.data.language) : ecommerceData?.[0]?.departure;
    if (!dateBegin || !dateEnd) {
      dateBegin = thn.dataLayerHelper.get('ecommerce.purchase')?.actionField?.arrival;
      dateEnd = thn.dataLayerHelper.get('ecommerce.purchase')?.actionField?.departure;
    }

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }
    const isCanadianDollarProperties = [1053037].includes(thn.data.propertyId);

    // Price & Currency
    const price = bookingData?.value || thn.objectGet(dataLayer, 'revenue', { first: false }) || (thn.dataLayerHelper.get('ecommerce.value') + thn.dataLayerHelper.get('ecommerce.tax'));
    const currency = isCanadianDollarProperties ? 'CAD' : bookingData?.currency || thn.dataLayerHelper.get('ecommerce.currency');
    widgetData.price = thn.parseNumber(price);
    widgetData.currency = thn.parseCurrency(currency);

    return widgetData;
  };

  return engine;
}

export { factory };
